import * as z from "zod";

export const getOkendoMarketingIntegration = {
  name: "getOkendoMarketingIntegration" as const,
  input: z.object({}),
  output: z.object({
    okendoMarketingIntegration: z
      .object({ okendoUserId: z.string(), enabled: z.boolean() })
      .optional(),
  }),
};

export type OkendoMarketingIntegrationDto = z.infer<
  typeof getOkendoMarketingIntegration.output
>["okendoMarketingIntegration"];
